// 「是否已经装成 App」的统一判断，供“我的”页的安装引导使用。
//
// 能可靠判断的只有「当前正在以 App 方式运行」：
//   - display-mode: standalone / fullscreen / minimal-ui（Android / 桌面 PWA）
//   - navigator.standalone（iOS 主屏幕图标启动）
//   - Capacitor 原生壳（APK）
//   - document.referrer 以 android-app:// 开头（TWA）
// 在普通浏览器标签页里，网页无法直接知道“别处是否已经装过”（iOS 的 Safari 和主屏 App 存储还是隔离的），
// 所以额外提供两个本地标记：
//   pwa_installed            —— 曾在 App 模式下运行过 / 收到过 appinstalled 事件（Android / 桌面浏览器与 PWA 共用存储，之后在标签页里也能读到）
//   install_guide_dismissed  —— 用户在引导卡片上点了“我已安装，不再提示”（iOS 只能靠这个）

const K_INSTALLED = 'pwa_installed';
const K_DISMISSED = 'install_guide_dismissed';

function lsGet(k) { try { return localStorage.getItem(k) === '1'; } catch (e) { return false; } }
function lsSet(k)  { try { localStorage.setItem(k, '1'); } catch (e) { /* 隐私模式等，忽略 */ } }

export function isNativeApp() {
  return !!(window.Capacitor?.isNativePlatform?.());
}

export function isStandaloneDisplay() {
  const mq = q => window.matchMedia && window.matchMedia(q).matches;
  return mq('(display-mode: standalone)')
      || mq('(display-mode: fullscreen)')
      || mq('(display-mode: minimal-ui)')
      || window.navigator.standalone === true
      || (document.referrer || '').startsWith('android-app://');
}

export function hasInstalledMark()   { return lsGet(K_INSTALLED); }
export function isGuideDismissed()   { return lsGet(K_DISMISSED); }
export function dismissInstallGuide() { lsSet(K_DISMISSED); }

// 在 index.js 里调用一次：App 模式下运行就打标记；浏览器里装完（appinstalled）也打标记
export function initInstallTracking() {
  if (typeof window === 'undefined') return;
  if (isStandaloneDisplay() || isNativeApp()) lsSet(K_INSTALLED);
  window.addEventListener('appinstalled', () => lsSet(K_INSTALLED));
}
